
import { defineComponent, onBeforeMount, onMounted, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// module components
import CourierForm from '@/modules/CouriersModule/components/CourierForm/index.vue'
import CouriersTableActionsButton from '@/modules/CouriersModule/components/CouriersTableActionsButton/index.vue'

// realisations
import { couriers } from '@/core/realisations/couriers.realisation'
import { dispatchers_sectors } from '@/core/realisations/dispatchers_sectors.realisation'
import { carriers } from '@/core/realisations/carriers.realisation'

// types
import {
    CourierPayloadT,
    DispatcherCourierT,
    CouirerCarT,
    CourierWorkDay,
    CourierTypeT,
} from '@/core/types/couriers.types'

import { DispatcherSectorT } from '@/core/types/dispatchers_sector.types'
import { CarrierT } from '@/core/types/carriers.types'

// classes
import { DataState } from '@/core/classes/DataState.class'

// consants
import { CouriersColumns } from '@/core/constants/columns/Couriers.columns'

// composable
import useActions from '@/common/composable/useActions'
import useHelpers from '@/common/composable/useHelpers'
import useNotifications from '@/common/composable/useNotifications'
import { useFile } from '@/common/composable/useFile'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

// !Hardcode
const COURIER_STATUSES = [
    {
        id: 1,
        name: 'На проверке(СБ)',
    },
    {
        id: 2,
        name: 'Активный',
    },
    {
        id: 3,
        name: 'В архиве',
    },
    {
        id: 4,
        name: 'Отказ СБ',
    },
]

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        'failed-fetch': FailedFetch,
        'table-scroll-wrapper': TableScrollWrapper,
        'the-table': TheTable,
        'couriers-table-actions-button': CouriersTableActionsButton,
        Cheap,
        'courier-form': CourierForm,
        modal: Modal,
        'the-input': TheInput,
        'the-select': TheSelect,
    },
    setup() {
        const { saveFile } = useFile()

        const state = reactive(new DataState<DispatcherCourierT>({}))
        const excel_state = reactive({
            is_loading: false,
        })

        const pagination_state = reactive({
            limit: 50,
        })

        const filters_state = reactive({
            full_name: null as string | null,
            id: null as number | null,
            iin: null as string | null,
            phoneNumber: null as string | null,
            company_id: null as number | null,
            dispatchers_sector_id: null as number | null,
            status_id: null as number | null,
            car_id: null as number | null,
            typesIds: [] as number[],
        })

        const couriers_copy = reactive({ list: [] as DispatcherCourierT[], is_search: false })

        const data_state = reactive({
            carriers: new DataState<CarrierT>({}),
            dispatchers_sectors: new DataState<DispatcherSectorT>({}),
            cars: new DataState<CouirerCarT>({}),
            types: new DataState<CourierTypeT>({}),
        })

        const loadCouriers = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true

                let carNumber: string | null = null

                if (filters_state.car_id) {
                    const { findObjectByValue } = useHelpers()
                    const finded = findObjectByValue(
                        'id',
                        filters_state.car_id,
                        data_state.cars.list
                    )

                    if (finded) {
                        carNumber = finded.number
                    }
                }

                const response = await couriers.getList({
                    page,
                    limit: pagination_state.limit,
                    id: filters_state.id,
                    name: filters_state.full_name,
                    iin: filters_state.iin,
                    phoneNumber: filters_state.phoneNumber,
                    companyId: filters_state.company_id,
                    dispatcherSectorIds: filters_state.dispatchers_sector_id
                        ? [filters_state.dispatchers_sector_id]
                        : [],
                    statusIds: filters_state.status_id ? [filters_state.status_id] : [],
                    carNumber,
                    typesIds: filters_state.typesIds,
                })

                state.list = response.data
                state.pagination.total_pages = response.meta.last_page
                state.pagination.total_items = response.meta.total

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        //

        const loadCarriers = async (page: number, search?: string) => {
            data_state.carriers.pagination.current_page = page

            try {
                const params = {
                    page,
                    search,
                    getAllCarriers: 1,
                    limit: 50,
                    statusId: 2,
                }

                data_state.carriers.is_loading = true
                const data = await carriers.getList(params)

                data_state.carriers.list = data.data
                data_state.carriers.pagination.total_pages = data.meta.last_page

                data_state.carriers.is_failed = false
                data_state.carriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.carriers.failure.catchError(error)

                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_failed = true
                }
            } finally {
                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_loading = false
                }
            }
        }

        const loadMoreCarriers = async (page: number) => {
            if (page > data_state.carriers.pagination.total_pages) return
            data_state.carriers.pagination.current_page = page

            try {
                const params = {
                    page,
                    getAllCarriers: 1,
                    limit: 50,
                    statusId: 2,
                }

                data_state.carriers.is_loading = true

                const response = await carriers.getList(params)
                data_state.carriers.list = data_state.carriers.list.concat(response.data)

                data_state.carriers.pagination.total_pages = response.meta.last_page

                data_state.carriers.is_failed = false
                data_state.carriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.carriers.failure.catchError(error)

                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_failed = true
                }
            } finally {
                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_loading = false
                }
            }
        }

        const searchCarriers = (search_query: string) => {
            loadCarriers(1, search_query)
        }

        const unshiftFindedCarrier = async (carrier: CarrierT) => {
            await loadCarriers(data_state.carriers.pagination.current_page)
            data_state.carriers.list.unshift(carrier)
        }

        //

        const loadCars = async (page: number, search: string | null = null) => {
            data_state.cars.pagination.current_page = page

            try {
                data_state.cars.is_loading = true

                const response = await couriers.getCars({
                    page,
                    number: search,
                    //
                    companyId: null,
                    ftlCarTypeId: null,
                    statusId: null,
                })

                data_state.cars.list = response.data
                data_state.cars.pagination.total_pages = response.meta.last_page

                data_state.cars.is_failed = false
                data_state.cars.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cars.failure.catchError(error)

                if (!data_state.cars.failure.error_state.is_cancel) {
                    data_state.cars.is_failed = true
                }
            } finally {
                if (!data_state.cars.failure.error_state.is_cancel) {
                    data_state.cars.is_loading = false
                }
            }
        }

        const loadMoreCars = async (page: number) => {
            if (page > data_state.cars.pagination.total_pages) return
            data_state.cars.pagination.current_page = page

            try {
                data_state.cars.is_loading = true

                const response = await couriers.getCars({
                    page,
                    //
                    number: null,
                    companyId: null,
                    ftlCarTypeId: null,
                    statusId: null,
                })
                data_state.cars.list = data_state.cars.list.concat(response.data)
                data_state.cars.pagination.total_pages = response.meta.last_page

                data_state.cars.is_failed = false
                data_state.cars.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cars.failure.catchError(error)

                if (!data_state.cars.failure.error_state.is_cancel) {
                    data_state.cars.is_failed = true
                }
            } finally {
                if (!data_state.cars.failure.error_state.is_cancel) {
                    data_state.cars.is_loading = false
                }
            }
        }

        const searchCars = (search_query: string) => {
            loadCars(1, search_query)
        }

        const unshiftFindedCars = async (car: CouirerCarT) => {
            await loadCars(data_state.cars.pagination.current_page)
            data_state.cars.list.unshift(car)
        }

        const onLimitChange = (limit: number) => {
            pagination_state.limit = limit
            loadCouriers(state.pagination.current_page)
        }

        //

        const loadTypes = async () => {
            try {
                data_state.types.is_loading = true

                const response = await couriers.getCourierTypes()

                data_state.types.list = response.data

                data_state.types.is_failed = false
                data_state.types.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.types.failure.catchError(error)

                if (!data_state.types.failure.error_state.is_cancel) {
                    data_state.types.is_failed = true
                }
            } finally {
                if (!data_state.types.failure.error_state.is_cancel) {
                    data_state.types.is_loading = false
                }
            }
        }

        // Add or update courier
        const { actions_state, startCreate, startUpdate } = useActions<DispatcherCourierT>()

        const notifications = useNotifications()

        const createCourier = async (courier_payload: FormData, schedules: CourierWorkDay[]) => {
            try {
                actions_state.is_actions_loading = true

                const response = await couriers.createCourier(courier_payload)
                state.list.push(response.data)

                notifications.notify({
                    title: 'Курьер создан',
                    type: 'success',
                })

                if (response.data && schedules.length) {
                    await couriers.createSchedule({
                        courierId: response.data.id,
                        schedules,
                    })

                    notifications.notify({
                        title: 'Расписание курьера создано',
                        type: 'success',
                    })
                }

                actions_state.is_actions_opened = false
            } catch (error) {
                notifications.notifyError({ error, title: 'При создании курьера произошла ошбика' })
            } finally {
                actions_state.is_actions_loading = false
            }
        }

        const updateCourier = async ({ id, payload }: { id: number; payload: CourierPayloadT }) => {
            if (!id) return

            try {
                actions_state.is_actions_loading = true

                const response = await couriers.updateCourier(id, payload)
                const { findItemIndexById } = useHelpers()

                const index = findItemIndexById(id, state.list)
                if (index < 0) return

                state.list[index] = response.data

                actions_state.is_actions_opened = false
            } catch (error) {
                console.error(error)
            } finally {
                actions_state.is_actions_loading = false
            }
        }

        const delete_state = reactive({
            is_opened: false,
            is_loading: false,
            courier: null as DispatcherCourierT | null,
        })

        const jira_state = reactive({
            is_loading: false,
        })

        const startDelete = (courier: DispatcherCourierT) => {
            delete_state.courier = courier
            delete_state.is_opened = true
        }

        const cancelDelete = () => {
            delete_state.is_opened = false
            delete_state.courier = null
        }

        const deleteCourier = async (courier_id: number) => {
            try {
                delete_state.is_loading = true

                await couriers.deleteCourier(courier_id)
                await loadCouriers(1)

                cancelDelete()
                notifications.notify({
                    title: 'Курьер удален',
                    type: 'success',
                })
            } catch (error) {
                notifications.notifyError({ error, title: 'При создании курьера произошла ошбика' })
            } finally {
                delete_state.is_loading = false
            }
        }

        const confirmDelete = () => {
            if (!delete_state.courier) return

            deleteCourier(delete_state.courier.id)
        }

        const exportExcel = async () => {
            try {
                excel_state.is_loading = true
                const response = await couriers.exportExcel({ ...filters_state })
                saveFile(response, 'Курьеры')
            } catch (e) {
                console.log(e)
            } finally {
                excel_state.is_loading = false
            }
        }

        const resetFilter = async () => {
            filters_state.full_name = null
            filters_state.id = null
            filters_state.iin = null
            filters_state.phoneNumber = null
            filters_state.company_id = null
            filters_state.dispatchers_sector_id = null
            filters_state.status_id = null
            filters_state.car_id = null
            filters_state.typesIds = []

            await loadCouriers(1)
        }

        const searchCourier = async () => {
            couriers_copy.is_search = true

            await loadCouriers(1)

            couriers_copy.is_search = false
        }

        const loadDispatchersSectors = async () => {
            try {
                data_state.dispatchers_sectors.is_loading = true

                const response = await dispatchers_sectors.getList()
                data_state.dispatchers_sectors.list = response.data

                data_state.dispatchers_sectors.is_failed = false
                data_state.dispatchers_sectors.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.dispatchers_sectors.failure.catchError(error)

                if (!data_state.dispatchers_sectors.failure.error_state.is_cancel) {
                    data_state.dispatchers_sectors.is_failed = true
                }
            } finally {
                if (!data_state.dispatchers_sectors.failure.error_state.is_cancel) {
                    data_state.dispatchers_sectors.is_loading = false
                }
            }
        }

        const normalizeDate = (date: string) => {
            let date_only = date.split('T')[0],
                time_only = date.split('T')[1].slice(0, 5)

            return `${date_only}, ${time_only}`
        }

        const cutName = (name: string, max_length: number): string => {
            if (name && name.length > max_length) {
                let name_parts = name.split('')
                name_parts = name_parts.splice(0, max_length - 1)
                name_parts.push('...')
                return name_parts.join('')
            }

            return name
        }

        const createJira = async () => {
            try {
                jira_state.is_loading = true

                await couriers.createJira()

                notifications.notify({
                    title: 'Курьеры созданы',
                    type: 'success',
                })
            } catch (error: any) {
                if (!error.length) {
                    notifications.notify({
                        title: 'При создании курьеров произошла ошбика!',
                        type: 'danger',
                    })
                } else {
                    notifications.notifyError({
                        error,
                        title: 'При создании курьеров произошла ошбика',
                    })
                }
            } finally {
                jira_state.is_loading = false
            }
        }

        //

        onBeforeMount(() => {
            loadDispatchersSectors()
        })

        onMounted(() => {
            loadCouriers(1)
            loadCarriers(1)
            loadCars(1)
            loadTypes()
        })

        //

        return {
            CouriersColumns,
            state,
            data_state,
            excel_state,
            filters_state,
            jira_state,
            pagination_state,
            //
            couriers_copy,
            loadCouriers,
            //
            loadCarriers,
            loadMoreCarriers,
            searchCarriers,
            unshiftFindedCarrier,
            //
            loadCars,
            loadMoreCars,
            searchCars,
            unshiftFindedCars,
            loadTypes,
            actions_state,
            startCreate,
            startUpdate,
            createCourier,
            updateCourier,
            delete_state,
            deleteCourier,
            startDelete,
            cancelDelete,
            confirmDelete,
            exportExcel,
            resetFilter,
            searchCourier,
            loadDispatchersSectors,
            normalizeDate,
            cutName,
            createJira,
            onLimitChange,
            //
            COURIER_STATUSES,
            formatDateWithTimeFromBackend,
        }
    },
})
